// extracted by mini-css-extract-plugin
export default {"h1":"Title_h1__l2VdV","h2":"Title_h2__uN7wX","h3":"Title_h3__KL6ji"};